import { createQueryKeys } from '@lukemorales/query-key-factory';

import { cezDownloadCV, getCezCvContext } from '@/services/cezCvGenerator';

export const cezCvGenerator = createQueryKeys('cezCvGenerator', {
  detail: (id: number) => ({
    queryFn: () => getCezCvContext(id),
    queryKey: [id],
    contextQueries: {
      blob: (
        args: Omit<Parameters<typeof cezDownloadCV>[0], 'id' | 'signal'>
      ) => ({
        queryKey: [args],
        queryFn: ({ signal }) => cezDownloadCV({ ...args, id, signal }),
      }),
    },
  }),
});
